import React from 'react';
import Proptypes from 'prop-types';
import { makeStyles } from '../../lib/styles';

const Cream = ({ checked }) => {
  const useStyles = makeStyles(theme => {
    return {
      wrap: {
        backgroundColor: theme.palette.common.white,
        height: 32,
        width: 32,
        borderRadius: 17,
        margin: 3,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      icon: {
        fill: checked ? theme.palette.primary.main : theme.palette.common.muted,
      },
    };
  });

  const { wrap, icon } = useStyles();

  return (
    <div className={wrap}>
      <svg
        width="12"
        height="24"
        viewBox="0 0 12 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={icon}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2887 4.28677C11.4527 5.03573 11.4595 5.81128 11.3087 6.56309C11.6964 6.94047 11.938 7.44615 11.9896 7.9885C12.0412 8.53086 11.8995 9.07402 11.5901 9.51956C11.5245 9.61402 11.4522 9.70276 11.3742 9.78524C11.448 10.3764 11.4263 10.977 11.3087 11.5631C11.6964 11.9405 11.938 12.4461 11.9896 12.9885C12.0412 13.5309 11.8995 14.074 11.5901 14.5196C11.2806 14.9651 10.824 15.2836 10.3029 15.4172C10.137 15.4598 9.96797 15.4827 9.79916 15.4864L6.37989 23.7668C6.35244 23.8349 6.30111 23.894 6.23304 23.9358C6.16497 23.9775 6.08352 24 6 24C5.91648 24 5.83503 23.9775 5.76696 23.9358C5.69888 23.894 5.64756 23.8349 5.62011 23.7668L2.20896 15.506C2.04444 15.5033 1.87961 15.4822 1.71746 15.4424C1.18917 15.3128 0.725176 14.9934 0.41155 14.5434C0.0979239 14.0934 -0.0440511 13.5433 0.0119599 12.9953C0.0679708 12.4472 0.318166 11.9384 0.716138 11.5631C0.651766 11.2217 0.619468 10.8748 0.619677 10.5272C0.617406 10.2963 0.629562 10.066 0.655876 9.83766C0.566905 9.74726 0.485094 9.64892 0.41155 9.54339C0.0979239 9.09338 -0.0440511 8.54334 0.0119599 7.99528C0.0679708 7.44723 0.318166 6.93837 0.716138 6.56309C0.651766 6.22167 0.619468 5.87483 0.619677 5.52723C0.612133 4.76007 0.763793 3.99988 1.06481 3.29598C1.36584 2.59208 1.80949 1.96021 2.367 1.44135C2.9245 0.922502 3.5834 0.528269 4.30092 0.284237C5.01845 0.0402055 5.77857 -0.048172 6.53197 0.024839C7.28537 0.0978504 8.01521 0.330619 8.67413 0.708041C9.33304 1.08546 9.90632 1.5991 10.3567 2.21563C10.8072 2.83216 11.1247 3.53781 11.2887 4.28677ZM1.61976 10.4161C1.61934 10.4498 1.6193 10.4836 1.61963 10.5174L1.61973 10.5278H1.61968C1.61951 10.8131 1.64601 11.0977 1.69882 11.3778L1.80017 11.9154L1.4022 12.2906C1.18033 12.4999 1.03856 12.786 1.00678 13.097C0.974986 13.408 1.05585 13.7189 1.23196 13.9716C1.40784 14.224 1.66577 14.4001 1.95573 14.4713C2.24547 14.5423 2.55112 14.5048 2.81694 14.3642L3.31282 14.102L3.7951 14.3885C4.4699 14.7893 5.23679 15 6.01695 15C6.79711 15 7.564 14.7893 8.2388 14.3885L8.71025 14.1084L9.19984 14.3554C9.46544 14.4893 9.76828 14.522 10.0544 14.4486C10.3408 14.3751 10.595 14.1993 10.7687 13.9492C10.9426 13.6987 11.0234 13.3914 10.9941 13.0832C10.9648 12.7752 10.8277 12.4904 10.6112 12.2797L10.2212 11.9001L10.3282 11.3664C10.3932 11.0427 10.4225 10.7135 10.4161 10.385C10.3788 10.3967 10.341 10.4075 10.3029 10.4172C9.78182 10.5509 9.23073 10.4909 8.7495 10.2482C7.92074 10.7405 6.97752 11 6.01695 11C5.05638 11 4.11316 10.7405 3.2844 10.2482C2.80249 10.503 2.24575 10.5721 1.71746 10.4424C1.68464 10.4344 1.65207 10.4256 1.61976 10.4161Z"
        />
      </svg>
    </div>
  );
};

Cream.propTypes = {
  checked: Proptypes.bool,
};

Cream.defaultProps = {
  checked: false,
};

Cream.displayName = 'Cream';

export default Cream;
